import FeaturesPage from './FeaturesPage';

export default FeaturesPage;
